var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.31818 12.8547C8.15805 12.357 7.87093 11.6112 7.43077 10.9693C6.99177 10.3291 6.23743 9.62367 5.61378 9.04045C5.18836 8.64259 4.82374 8.30161 4.66153 8.07701C4.26153 7.52317 4.19998 6.96932 4.3846 6.35394C4.44613 6.96932 4.75383 7.43086 5.39998 7.67702C5.66902 7.77951 6.05942 7.84434 6.47956 7.91411C7.06848 8.01192 7.71583 8.11942 8.16923 8.35394C8.49094 8.52034 8.73949 8.75801 8.96084 8.96968C9.35343 9.34509 9.66047 9.6387 10.1384 9.30778C10.3667 9.14975 10.635 9.04345 10.8519 8.95749C11.0151 8.89283 11.1492 8.83969 11.2154 8.78471C11.3956 8.63484 11.3317 8.20939 11.1846 7.73855C11.1111 7.50329 10.9743 7.26804 10.7576 6.89511L10.7575 6.8951L10.7575 6.89509C10.5445 6.52868 10.2543 6.02937 9.87087 5.26659V6.60001H5.86148V2.78463H8.39297C8.29813 2.66304 8.21125 2.55707 8.13219 2.46064L8.13217 2.46062L8.13216 2.46061C8.05508 2.3666 7.98543 2.28164 7.92307 2.20009C7.92307 2.20009 8.19999 1.8924 8.72307 1.67701C8.01538 1.46163 7.39999 1.55394 7.39999 1.55394L7.69155 1.03942C7.46464 1.01338 7.23388 1 7 1C3.68629 1 1 3.68629 1 7C1 10.3137 3.68629 13 7 13C7.45286 13 7.89401 12.9498 8.31818 12.8547ZM9.12306 3.40009H6.59999V5.92317H9.12306V3.40009Z",
    fill: "#189C15"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.631f0cebbcac0bacf8ecc0ede01bc542.svg";
export { ForwardRef as ReactComponent };